<mat-card class="model-config-card">
  <mat-card-header>
    <div class="header-with-actions">
      <div class="header-content">
        <mat-icon class="header-icon">psychology</mat-icon>
        <div class="header-text">
          <mat-card-title>Model Configuration</mat-card-title>
          <mat-card-subtitle>Select which AI model profile is used for each task</mat-card-subtitle>
        </div>
      </div>
      @if (hasUnsavedChanges && !loading) {
        <div class="header-actions">
          <div class="action-buttons">
            <button
              mat-mini-fab
              class="discard-button"
              (click)="discardChanges()"
              [disabled]="saving"
              matTooltip="Discard changes"
              matTooltipPosition="below"
              aria-label="Discard changes"
            >
              <mat-icon>undo</mat-icon>
            </button>
            <button
              mat-mini-fab
              class="save-button"
              (click)="saveChanges()"
              [disabled]="saving"
              matTooltip="Save changes"
              matTooltipPosition="below"
              aria-label="Save changes"
            >
              <mat-icon>save</mat-icon>
            </button>
          </div>
        </div>
      }
    </div>
  </mat-card-header>

  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  @if (saving) {
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
  }

  <mat-card-content>
    @if (error) {
      <div class="error-message">{{ error }}</div>
    }

    @if (!loading && useCaseRows.length > 0) {
      <div class="config-table">
        <div class="table-header">
          <span class="col-use-case">Use Case</span>
          <span class="col-profile">Profile</span>
          <span class="col-model">Model</span>
          <span class="col-temp">Temp</span>
          <span class="col-tokens">Max Tokens</span>
          <span class="col-actions"></span>
        </div>
        @for (row of useCaseRows; track row.useCase) {
          <div class="table-row" [class.overridden]="row.isOverridden">
            <div class="col-use-case">
              <span class="use-case-name">{{ row.displayName }}</span>
              @if (row.isOverridden) {
                <span class="overridden-badge">Overridden</span>
              }
            </div>
            <div class="col-profile">
              <mat-select
                class="profile-select"
                [value]="row.selectedProfileId"
                [attr.aria-label]="'Model profile for ' + row.displayName"
                (selectionChange)="onProfileChange(row, $event.value)"
              >
                @for (profile of profiles; track profile.profileId) {
                  <mat-option [value]="profile.profileId">
                    {{ profile.displayName }}
                    @if (profile.profileId === row.defaultProfileId) {
                      <span class="default-indicator">(default)</span>
                    }
                  </mat-option>
                }
              </mat-select>
            </div>
            <div class="col-model">
              <code class="model-id">{{ getSelectedProfile(row)?.modelName || '—' }}</code>
            </div>
            <div class="col-temp">
              {{ getSelectedProfile(row)?.temperature ?? '—' }}
            </div>
            <div class="col-tokens">
              @if (getSelectedProfile(row)?.maxOutputTokens) {
                {{ getSelectedProfile(row)?.maxOutputTokens | number }}
              } @else {
                <span class="muted">default</span>
              }
            </div>
            <div class="col-actions">
              @if (row.isOverridden) {
                <button
                  mat-icon-button
                  class="reset-button"
                  (click)="resetToDefault(row)"
                  matTooltip="Reset to inherited default: {{ getProfileDisplayName(row.defaultProfileId) }}"
                  matTooltipPosition="left"
                  attr.aria-label="Reset {{ row.displayName }} to default profile"
                >
                  <mat-icon>restart_alt</mat-icon>
                </button>
              }
            </div>
          </div>
        }
      </div>
    }
  </mat-card-content>
</mat-card>
